import { useEffect, useState } from 'react';
import { nowMs } from '../utils/clock';

const pad = (n: number) => String(n).padStart(2, '0');

/** Current time (server-corrected), updated every second. */
export function useNow(intervalMs = 1000): number {
  const [now, setNow] = useState(nowMs());
  useEffect(() => {
    const id = setInterval(() => setNow(nowMs()), intervalMs);
    return () => clearInterval(id);
  }, [intervalMs]);
  return now;
}

/** Countdown to a date, with 2-digit values. Stops at zero. */
export function useCountdown(targetIso: string) {
  const now = useNow();
  const total = Math.max(
    0,
    Math.floor((new Date(targetIso).getTime() - now) / 1000)
  );
  return {
    total,
    d: pad(Math.floor(total / 86400)),
    h: pad(Math.floor((total % 86400) / 3600)),
    m: pad(Math.floor((total % 3600) / 60)),
    s: pad(total % 60),
  };
}

/** Seconds since a date (time on site since check-in). */
export function useElapsedSeconds(startIso: string | null): number {
  const now = useNow();
  if (!startIso) return 0;
  return Math.max(0, Math.floor((now - new Date(startIso).getTime()) / 1000));
}
